// Test IDs for the FITUR 2027 landing page.
export const LANDING = {
    // Nav
    navLogo: 'nav-logo',
    navCtaBook: 'nav-cta-book',
    navLinkMethod: 'nav-link-method',
    navLinkPhases: 'nav-link-phases',
    navLinkPricing: 'nav-link-pricing',
    navLinkContact: 'nav-link-contact',

    // Hero
    heroTitle: 'hero-title',
    heroCtaBook: 'hero-cta-book',
    heroCtaWhatsapp: 'hero-cta-whatsapp',

    // Matrix
    matrixCardEscalar: 'matrix-card-escalar',
    matrixCardInnovacion: 'matrix-card-innovacion',
    matrixCardAprender: 'matrix-card-aprender',
    matrixCardRed: 'matrix-card-red',

    // Phases
    phaseOne: 'phase-one',
    phaseTwo: 'phase-two',
    phaseThree: 'phase-three',

    // Pricing
    pricingCardLanzamiento: 'pricing-card-lanzamiento',
    pricingCardEarlybird: 'pricing-card-earlybird',
    pricingCardRegular: 'pricing-card-regular',
    pricingCardLastcall: 'pricing-card-lastcall',
    pricingCtaBook: 'pricing-cta-book',

    // Mental Prep
    mentalPrepList: 'mental-prep-list',

    // Program video
    videoSection: 'program-video-section',
    videoPlay: 'program-video-play',
    videoPlayer: 'program-video-player',

    // Testimonials
    testimonialSection: 'testimonial-section',
    testimonialPlay: 'testimonial-play',
    testimonialPlayer: 'testimonial-player',

    // Form (multi-step)
    formSection: 'form-section',
    formOpen: 'form-open',
    formStep: 'form-step',
    formInputName: 'form-input-name',
    formInputEmail: 'form-input-email',
    formInputCompany: 'form-input-company',
    formInputCountry: 'form-input-country',
    formInputRole: 'form-input-role',
    formInputWebsite: 'form-input-website',
    formInputWhatsapp: 'form-input-whatsapp',
    formInputNotes: 'form-input-notes',
    formSelectObjectiveEscalar: 'form-select-objective-escalar',
    formSelectObjectiveInnovacion: 'form-select-objective-innovacion',
    formSelectObjectiveAprender: 'form-select-objective-aprender',
    formSelectObjectiveRed: 'form-select-objective-red',
    formSelectStageIdea: 'form-select-stage-idea',
    formSelectStageMvp: 'form-select-stage-mvp',
    formSelectStageEscala: 'form-select-stage-escala',
    formBtnNext: 'form-btn-next',
    formBtnBack: 'form-btn-back',
    formBtnSubmit: 'form-btn-submit',
    formSuccess: 'form-success',
    formSuccessSchedule: 'form-success-schedule',
    formSuccessWhatsapp: 'form-success-whatsapp',

    // Floating
    floatWhatsapp: 'float-whatsapp',

    // Footer
    footerEmail: 'footer-email',
    footerWhatsapp: 'footer-whatsapp',
    footerSocialInstagram: 'footer-social-instagram',
    footerSocialFacebook: 'footer-social-facebook',
    footerSocialLinkedin: 'footer-social-linkedin',
    footerWebsite: 'footer-website',
};
